import {Component, OnInit, ElementRef, Input, ViewChild, Output, EventEmitter, Renderer2} from '@angular/core';
import {formatNumber} from '@angular/common';
import * as d3 from 'd3';
import {Globals} from '../globals';

declare var d3pie: any; // referencing d3pie.js

@Component({
  selector: 'app-d3pie',
  templateUrl: './d3pie.component.html',
  styleUrls: ['./d3pie.component.css']
})
export class D3pieComponent implements OnInit {
  @Input() params: string = '';
  @Input() token: string = '';
  @Input() data:any = null;
  @Output() dataEvent = new EventEmitter<any>();
  @ViewChild('view') panel: ElementRef<HTMLDivElement> | undefined;

  pie: any = null;
  oldTitle: string = '';
  title: string = '';
  subtitle: string =  '';
  loading: boolean = false;

  constructor(private globals: Globals) { }

  ngOnInit(): void {
    if(this.data == null) this.showD3(this.params);
    else setTimeout(()=>this.drawChart(this), 100); // need time to init the panel
  }

  showD3(params: string): void {
    let me = this;
    me.loading = true;
    let data = d3.json(this.globals.url_root + "/Query.action?sql=SQL_JSON_AIRPORT_CHECKPOINT"+params, {
      headers: new Headers({
        "Authorization": "Bearer " + this.token
      })
    });
    data.then(function(data) {
      me.loading = false;
      me.data = data;
      me.dataEvent.emit(data);

      me.drawChart(me);
    });
  }

  createPieChart(content: any, me: any): void {
    let width = 1000;
    let height = 600;
    if(this.panel) {
      height = this.panel.nativeElement.offsetHeight;
      width = this.panel.nativeElement.offsetWidth;
      if(height > width) {
        height = width * 0.8;
      }
    }
    let minimum = 1, innerRadius = 45, outerRadius = 85;

    me.subtitle = "Click on a segment to drill down";
    if (me.title.startsWith("Break-down")) {
      me.subtitle = "Click on a segment to go back";
    }
    let config = {
      "header": {
        "title": {
          "fontSize": 24,
          "font": "open sans"
        },
        "subtitle": {
          "color": "#999999",
          "fontSize": 12,
          "font": "open sans"
        },
        "titleSubtitlePadding": 0
      },
      "size": {
        "canvasWidth": width,
        "canvasHeight": height,  // Same as width
        "pieInnerRadius": innerRadius + "%",
        "pieOuterRadius": outerRadius + "%"
      },
      "data": {
        "sortOrder": "value-desc",
        "smallSegmentGrouping": {
          "enabled": true,
          "value": minimum
        },
        "content": content
      },
      "labels": {
        "outer": {
          "pieDistance": 32,
          "hideWhenLessThanPercentage": 2.0
        },
        "inner": {
          "hideWhenLessThanPercentage": 2.0
        },
        "mainLabel": {
          "fontSize": 11
        },
        "percentage": {
          "color": "#ffffff",
          "decimalPlaces": 1
        },
        "value": {
          "color": "#adadad",
          "fontSize": 11
        },
        "lines": {
          "enabled": true
        },
        "truncation": {
          "enabled": true
        }
      },
      "tooltips": {
        "enabled": true,
        "type": "placeholder",
        "string": "{label}: {value} ({percentage}%)",
        placeholderParser: (index: number, data: any) => {
          data.value = formatNumber(data.value, 'en-US', '1.0-0');
        }
      },
      "effects": {
        "load": {
          "speed": 500
        },
        "pullOutSegmentOnClick": {
          "effect": "linear",
          "speed": 400,
          "size": 8
        }
      },
      "misc": {
        "gradient": {
          "enabled": true,
          "percentage": 100
        }
      },
      "callbacks": {
        onClickSegment: function(a: any) {
          if (me.title.startsWith("Break-down")) {
            // Go back
            me.title = me.oldTitle;
            me.drawChart(me);
          } else {
            // Drill down
            let data = d3.hierarchy(me.data)
              .sum((d: any) => d.value)
              .sort((a: any, b: any) => b.value - a.value)
              .eachAfter((d: any) => d.index = d.parent ? d.parent.index = d.parent.index + 1 || 0 : 0);
            data.each(function (record: any) {
              if (record.data.name == a.data.label && record.data.children) {
                let color = d3.scaleOrdinal(d3.schemeCategory10);
                let content: any[] = [];
                let count: number = 0;
                record.data.children.forEach(function (item: any) {
                  content.push({
                    "label": item.name,
                    "value": item.value,
                    "color": color((count++).toString())
                  });

                });
                me.oldTitle = me.title; // Need to be before createPieChart
                me.title = "Break-down of Traffic at " + a.data.label;
                me.createPieChart(content, me);
              }
            });
          }
        }
      }
    };

    if(me.pie) me.pie.destroy();
    me.pie = new d3pie('d3pie', config);
  };

  drawChart(me: any): void {
    me.title = "Traffic Distribution by Airport";
    me.subtitle = "Click on a segment to drill down";

    let root = d3.hierarchy(me.data)
      .sum((d: any) => d.value)
      .sort((a: any, b: any) => b.value - a.value)
      .eachAfter((d: any) => d.index = d.parent ? d.parent.index = d.parent.index + 1 || 0 : 0);

    let color = d3.scaleOrdinal(d3.schemeCategory10);
    let content: any[] = [];
    root.each(function(item: any) {
      if(item.children && item.children.length > 0 && item.data.name != 'data') {
        content.push({
          "label": item.data.name,
          "value": item.value,
          "color": color(item.index)
        });
      }
    });
    me.createPieChart(content, me);

    // // Workaround about the issue that some segments disappear
    // setTimeout(function(){
    //   me.pie.updateProp("effects.load.effect", "none");
    // }, 1000);
  };

  onResize(): void {
    if(this.panel != null) {
      this.drawChart(this);
    }
  }

}
